import { render, staticRenderFns } from "./NewFeedback.vue?vue&type=template&id=f02bead0&scoped=true&"
import script from "./NewFeedback.vue?vue&type=script&lang=js&"
export * from "./NewFeedback.vue?vue&type=script&lang=js&"
import style0 from "./NewFeedback.vue?vue&type=style&index=0&id=f02bead0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02bead0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VCol,VRow,VSpacer,VTextField,VTextarea})
